import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'

const RecurringTransferUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  paymentAmount, onPaymentAmountChange, paymentAmountError, setPaymentAmountError,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update standing instructions'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF
      type='text' name='paymentAmount' label='Payment amount'
      value={paymentAmount} onChange={onPaymentAmountChange}
      error={paymentAmountError} setError={setPaymentAmountError}
      required={true}
    />
  </ModalFormUI>

export default RecurringTransferUpdateModalUI
